var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeFeature2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#home-feature2_svg__filter0_d)",
    clipPath: "url(#home-feature2_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.333 7H34.58C33.6 4.293 31.033 2.333 28 2.333S22.4 4.293 21.42 7h-9.753A4.68 4.68 0 007 11.667v32.666A4.68 4.68 0 0011.667 49h32.666A4.68 4.68 0 0049 44.333V11.667A4.68 4.68 0 0044.333 7zM28 7a2.34 2.34 0 012.333 2.333A2.34 2.34 0 0128 11.667a2.34 2.34 0 01-2.333-2.334A2.34 2.34 0 0128 7zm-11.667 9.333h23.334v-4.666h4.666v32.666H11.667V11.667h4.666v4.666zM28 39.667V35h11.667v4.667H28zm0-14V21h11.667v4.667H28zM18.667 28v-7h-2.334v-2.333H21V28h-2.333zm2.916 4.667c.957 0 1.75.793 1.75 1.75 0 .466-.186.91-.49 1.213l-3.896 4.037h4.386V42h-7v-2.147L21 35h-4.667v-2.333h5.25z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "home-feature2_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "home-feature2_svg__filter0_d",
    x: -2,
    y: -2.667,
    width: 60,
    height: 64.667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.105882 0 0 0 0 0.454902 0 0 0 0 0.909804 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
export default SvgHomeFeature2;